<template>
  <v-list dense>
    <template v-if="rules.length > 0" v-for="(item, i) in navLinks">
      <v-list-group :value="true" :prepend-icon="item.icon" v-if="item.children">

        <template v-slot:activator>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </template>

        <v-list-item v-if="child.gate === undefined || checkGate(child.gate)" v-for="child in item.children"
          :key="child.title" :to="child.path" link>

          <v-list-item-content>
            {{ child.title }}</v-list-item-content>

        </v-list-item>

      </v-list-group>


      <v-list-item v-else-if="item.gate === undefined || checkGate(item.gate)" :key="`item-${i}`" :to="item.path" link>
        <v-list-item-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          {{ item.title }}</v-list-item-content>
      </v-list-item>
    </template>

  </v-list>
</template>
<script>
import { mapState } from 'vuex'
export default {

  props: {

    navLinks: {
      type: Array,
      default: () => []
    }

  },

  computed: {

    ...mapState(['rules'])

  },

}
</script>